import { render, staticRenderFns } from "./InstanceOverview.vue?vue&type=template&id=e52d5d34&"
import script from "./InstanceOverview.vue?vue&type=script&lang=js&"
export * from "./InstanceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports